import React from "react"

const CheckBoxInput = (props) => {

    const {input: {value, onChange, checked, name}, meta: {touched, error} } = props;
    return (
        <div className="terms" id={name+"-message"}>
            <div className="checkbox forms__group">
                <div className="">
                    <div className="input-wrap checkbox-wrap">
                        <input type="checkbox" name={name} value={value}
                               id={props.id} checked={checked} onChange={onChange}/>
                        <label htmlFor={name}>{props.title}</label>
                    </div>
                    {touched && (error && <div className="validation-error">{error.message}</div>) }
                </div>
            </div>
        </div>)


};

export default CheckBoxInput